import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  
  // Check if admin is authenticated
  const adminToken = localStorage.getItem('adminToken');
  const adminUserStr = localStorage.getItem('adminUser');
  
  if (!adminToken || !adminUserStr) {
    // Redirect to admin login if not authenticated
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  
  try {
    const adminUser = JSON.parse(adminUserStr);
    
    // Check if user has SUPER_ADMIN role
    if (adminUser.adminRole !== 'SUPER_ADMIN') {
      // Remove invalid admin session
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }
    
    // Check if token is expired (optional - you can add JWT decode here)
    // For now, we'll rely on the backend to validate the token
    
    return <>{children}</>;
  } catch (error) {
    // Invalid admin user data
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
};

export default AdminProtectedRoute;